module.exports = __webpack_public_path__ + "static/media/sanitaer_richtig.e8a9f359.jpg";